import { create } from 'zustand';

// 滷水/冷藏即時快照（後端 brine_ingest 經 WebSocket "brine_update" 推送）
export interface BrineMetric {
  pv: number | null;
  unit?: string;
}

export interface BrineDevice {
  device_key: string;       // brine_main / cold_1f1 / cold_1f2 / cold_2f
  name: string;
  category: string;         // brine | cold
  metrics: Record<string, BrineMetric>;   // 中文點名 → {pv, unit}
  states: Record<string, boolean>;        // 中文點名 → 開/關
  alarms: { code: string; active: boolean }[];
  online: boolean;
  last_update: string;      // HH:MM:SS
}

export interface BrineSnapshot {
  connected: boolean;
  msg_count: number;
  timestamp: string;
  devices: Record<string, BrineDevice>;
}

interface BrineState {
  snapshot: BrineSnapshot | null;
  setSnapshot: (s: BrineSnapshot) => void;
}

const useBrineStore = create<BrineState>((set) => ({
  snapshot: null,
  setSnapshot: (snapshot) => set({ snapshot }),
}));

export default useBrineStore;
